<mat-sidenav-container class="global-sidenav-container">
  <mat-sidenav-content>
    <ng-container *ngIf="!hideChrome; else chromeFreeTpl">
      <app-topbar></app-topbar>
      <div class="app-layout" [ngClass]="{ 'navbar-contracted': checkIsCollapsed }">
        <app-navbar *appHasRole="['centeradmin', 'groupadmin', 'centeruser']" class="app-navbar"
          (isCollapsedEvent)="changeCheck($event)"></app-navbar>
        <div #content class="app-content" [ngClass]="{'full-width': userRole === 'superadmin'}">
          <app-spinner></app-spinner>
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-chat-fab *appHasRole="['centeradmin', 'groupadmin', 'centeruser']"></app-chat-fab>
      <app-chat-modal *appHasRole="['centeradmin', 'groupadmin', 'centeruser']"></app-chat-modal>
      <app-cafi-welcome *appHasRole="['centeradmin', 'groupadmin', 'centeruser']"></app-cafi-welcome>
    </ng-container>
    <ng-template #chromeFreeTpl>
      <router-outlet></router-outlet>
    </ng-template>
  </mat-sidenav-content>

  <mat-sidenav #globalDrawer class="global-sidenav" position="end" mode="over" [opened]="isDrawerOpen$ | async"
    (closed)="closeDrawer()" [style.width]="currentDrawerWidth">
    <div class="drawer-header">
      <h2>{{ getDrawerTitle() }}</h2>
      <button class="close-button" (click)="closeDrawer()">×</button>
    </div>
    <div class="drawer-content" [ngClass]="{'no-header': hasCustomHeader()}">
      <ng-container *ngIf="currentDrawerComponentType">
        <ng-container *ngComponentOutlet="currentDrawerComponentType; 
                                          injector: currentDrawerInjector">
        </ng-container>
      </ng-container>
    </div>
  </mat-sidenav>
</mat-sidenav-container>

<!-- Global indicator for bulk-upload background jobs.
     Renders outside mat-sidenav-container so it stays fixed to the viewport
     regardless of which route is active. -->
<app-bulk-upload-status-indicator></app-bulk-upload-status-indicator>